import { cn } from '@reelplicate/ui/lib/utils';
import * as React from 'react';

/**
 * shadcn Input, reduced to the bare text field. The Figma "Text Input" box -
 * border, fill, states, icons - is `TextInput` (components/lib), which renders
 * this inside it. Use `TextInput` in apps.
 */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'h-full w-full min-w-0 bg-transparent text-inherit outline-none',
        'placeholder:text-text-tertiary selection:bg-brand-subtle',
        'disabled:cursor-not-allowed disabled:text-text-disabled disabled:placeholder:text-text-disabled',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
